import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import { storyPoints } from "@/mocks/siteData";

const phaseIcon: Record<string, string> = {
  序章: "ri-door-open-line",
  第一章: "ri-eye-line",
  第二章: "ri-heart-line",
  第三章: "ri-compass-3-line",
};

export default function StoryPreview() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <SectionHeading
          eyebrow="剧情与世界观"
          title="从接过钥匙的那一刻说起"
          desc="继承杂货店、墙上的洞、村里的人情，再到横跨百年的真相——四段脉络勾勒出整部作品的世界观。"
        />
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {storyPoints.map((p, idx) => (
            <article
              key={p.id}
              className="relative flex h-full flex-col rounded-lg border border-background-200/70 bg-background-50 p-5"
            >
              <span className="flex items-center gap-2 text-xs font-bold text-accent-700">
                <i className={`${phaseIcon[p.phase] ?? "ri-star-line"} text-base`} />
                {p.phase}
              </span>
              <span className="mt-4 font-heading text-3xl font-black text-background-300">
                0{idx + 1}
              </span>
              <h3 className="mt-1 font-heading text-base font-bold text-foreground-950">
                {p.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{p.text}</p>
            </article>
          ))}
        </div>
        <div className="mt-10 text-center">
          <Link
            to="/story"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-5 py-2.5 text-sm font-bold text-primary-700 transition-colors hover:bg-primary-50"
          >
            深入了解剧情世界观
            <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}